import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { KeyRound, ArrowLeft, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || (window.location.origin + '/api');

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [newPwd, setNewPwd]       = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [loading, setLoading]     = useState(false);
  const [done, setDone]           = useState(false);
  const [error, setError]         = useState('');

  if (!token) {
    return (
      <div style={pageStyle}>
        <div className="card" style={{ padding: 32, maxWidth: 420, textAlign: 'center' }}>
          <p style={{ color: 'var(--red)', marginBottom: 16 }}>Link inválido o expirado.</p>
          <Link to="/forgot-password" style={linkStyle}>Solicitar un nuevo link</Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPwd !== confirmPwd) { setError('Las contraseñas no coinciden.'); return; }
    if (newPwd.length < 8) { setError('La contraseña debe tener al menos 8 caracteres.'); return; }
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: newPwd }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setDone(true);
    } catch (err) {
      setError(err.message || 'Error restableciendo contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={pageStyle}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, background: 'var(--ink)', borderRadius: 14, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
            <KeyRound size={26} color="#fff" />
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--ink)', margin: '0 0 4px' }}>Nueva contraseña</h1>
          <p style={{ fontSize: 13, color: 'var(--ink-3)', margin: 0 }}>NODWARD</p>
        </div>

        <div className="card" style={{ padding: 32 }}>
          {!done ? (
            <>
              <p style={{ fontSize: 14, color: 'var(--ink-2)', marginBottom: 24, textAlign: 'center' }}>
                Elegí una nueva contraseña para tu cuenta.
              </p>

              {error && (
                <div style={{ background: 'var(--red-dim)', border: '1px solid var(--red-dim)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--red)', marginBottom: 16 }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 6 }}>
                    Nueva contraseña
                  </label>
                  <input
                    type="password" required autoFocus
                    value={newPwd} onChange={e => setNewPwd(e.target.value)}
                    placeholder="Mínimo 8 caracteres"
                    style={{ width: '100%', padding: '11px 14px', border: '1.5px solid var(--border)', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 6 }}>
                    Confirmar contraseña
                  </label>
                  <input
                    type="password" required
                    value={confirmPwd} onChange={e => setConfirmPwd(e.target.value)}
                    placeholder="Repetí la nueva contraseña"
                    style={{ width: '100%', padding: '11px 14px', border: `1.5px solid ${confirmPwd && newPwd !== confirmPwd ? 'var(--red-dim)' : 'var(--border)'}`, borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                  />
                  {confirmPwd && newPwd !== confirmPwd && (
                    <div style={{ fontSize: 11, color: 'var(--red)', marginTop: 4 }}>Las contraseñas no coinciden</div>
                  )}
                </div>

                {/* Indicador de fuerza */}
                {newPwd.length > 0 && (
                  <div style={{ fontSize: 11, color: newPwd.length < 8 ? 'var(--red)' : newPwd.length < 12 ? 'var(--amber)' : 'var(--green)' }}>
                    {newPwd.length < 8 ? '⚠ Muy corta (mínimo 8 caracteres)' : newPwd.length < 12 ? '✓ Aceptable' : '✓✓ Contraseña fuerte'}
                  </div>
                )}

                <button
                  type="submit" disabled={loading || (confirmPwd && newPwd !== confirmPwd)}
                  style={{ padding: '12px 0', background: 'var(--ink)', color: 'var(--surface)', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 4 }}>
                  <KeyRound size={16} />
                  {loading ? 'Guardando...' : 'Establecer nueva contraseña'}
                </button>
              </form>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--green-dim)', border: '2px solid var(--green-dim)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
                <Check size={28} color="var(--green)" />
              </div>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: 'var(--ink)', margin: '0 0 8px' }}>¡Contraseña actualizada!</h2>
              <p style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.6, margin: '0 0 24px' }}>
                Tu contraseña fue restablecida correctamente. Ya podés iniciar sesión con tu nueva contraseña.
              </p>
              <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--surface)', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>
                Ir al inicio de sesión
              </Link>
            </div>
          )}

          {!done && (
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link to="/login" style={linkStyle}>
                <ArrowLeft size={14} /> Volver al inicio de sesión
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const pageStyle = {
  minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'linear-gradient(135deg, var(--bg-subtle) 0%, #e0e7ff 100%)', padding: 24,
};
const linkStyle = {
  color: 'var(--accent)', fontSize: 13, textDecoration: 'none',
  display: 'inline-flex', alignItems: 'center', gap: 4, fontWeight: 500,
};
